import Tooltip from '@components/common/Tooltip';

const Chart = () => {
    return (
        <>
            <div className="custom-card card hrm-main-card secondary">
                <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <div className="avatar avatar-md rounded-4 bg-secondary shadow shadow-secondary text-fixed-white">
                                <i className="ri-bubble-chart-line fs-18"></i>
                            </div>
                        </div>
                        <div className="flex-fill">
                            <p className="mb-1 text-muted">
                                인산광합성
                                <Tooltip
                                    content="도움말이 표시될예정"
                                    customClass="tooltip-dark"
                                    placement="top"
                                >
                                    <i className="ri-question-line" />
                                </Tooltip>
                            </p>
                            <div className="d-flex align-items-top justify-content-between">
                                <h5 className="fw-semibold mb-0 lh-1">중간</h5>
                                <div className="text-secondary fw-semibold">
                                    0.51
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        role="progressbar"
                        aria-valuenow="65"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        className="progress progress-lg p-1 progress-animate progress"
                    >
                        <div
                            role="progressbar"
                            className="progress-bar progress-bar-striped bg-secondary progress-bar"
                            aria-valuenow="65"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: '65%' }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart;
